// Entity types
export const EntityType = {
    PAWN: 1,
    BUILDING: 2,
    RESOURCE: 3,
    ITEM: 4,
    WORLD_OBJECT: 5,
    ANIMAL: 6,
    CORPSE: 7,
};
// Default values for creating new pawn snapshots
export const DEFAULT_PAWN_VALUES = {
    vx: 0,
    vy: 0,
    state: 0,
    hunger: 100,
    rest: 100,
    mood: 50,
    path: null,
    pathIndex: 0,
    targetX: null,
    targetY: null,
    skills: [],
    task: null,
    isDowned: 0,
    isUnconscious: 0,
    carriedByNetworkId: 0,
    carryingNetworkId: 0,
    restingInBedNetworkId: 0,
};
// Helper to create a full pawn snapshot from partial data
export const createPawnSnapshot = ({ networkId, x, y, health, maxHealth, ownerId, name, ...optional }) => {
    const defaults = { ...DEFAULT_PAWN_VALUES };
    return {
        ...defaults,
        ...optional,
        networkId,
        entityType: EntityType.PAWN,
        x,
        y,
        health,
        maxHealth,
        ownerId,
        name,
    };
};
//# sourceMappingURL=types.js.map